document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initMarqueeAnuncio();
  initAcordeonPoliticas();
  initBarraFlotante();
  document.querySelectorAll('[data-mt-hero-galeria]').forEach(initHeroGaleria);
  document.querySelectorAll('[data-mt-testimonios]').forEach(initTestimoniosCarrusel);
});

function initTestimoniosCarrusel(contenedor) {
  var track = contenedor.querySelector('[data-mt-testimonios-track]');
  if (!track || track.getAttribute('data-mt-listo')) return;
  track.setAttribute('data-mt-listo', '1');

  var tarjetasOriginales = Array.prototype.slice.call(track.children);
  if (!tarjetasOriginales.length) return;

  tarjetasOriginales.forEach(function (tarjeta) {
    var copia = tarjeta.cloneNode(true);
    copia.setAttribute('aria-hidden', 'true');
    copia.setAttribute('tabindex', '-1');
    track.appendChild(copia);
  });

  var velocidad = parseFloat(contenedor.getAttribute('data-mt-velocidad')) || 30;
  var mitad = 0;
  var pxPorSegundo = 0;
  var pausado = false;
  var arrastrando = false;
  var movio = false;
  var inicioX = 0;
  var inicioScroll = 0;

  function calcularMitad() {
    mitad = track.scrollWidth / 2;
    pxPorSegundo = velocidad > 0 ? mitad / velocidad : 0;
  }
  calcularMitad();
  window.addEventListener('resize', calcularMitad);

  function normalizar() {
    if (mitad <= 0) return;
    if (contenedor.scrollLeft >= mitad) {
      contenedor.scrollLeft -= mitad;
    } else if (contenedor.scrollLeft < 0) {
      contenedor.scrollLeft += mitad;
    }
  }

  var ultimoTiempo = null;
  function animar(tiempo) {
    if (ultimoTiempo === null) ultimoTiempo = tiempo;
    var delta = (tiempo - ultimoTiempo) / 1000;
    ultimoTiempo = tiempo;
    if (!pausado && !arrastrando) {
      contenedor.scrollLeft += pxPorSegundo * delta;
      normalizar();
    }
    requestAnimationFrame(animar);
  }
  requestAnimationFrame(animar);

  contenedor.addEventListener('mouseenter', function () { pausado = true; });
  contenedor.addEventListener('mouseleave', function () { pausado = false; });

  function mover(evento) {
    var delta = evento.clientX - inicioX;
    if (Math.abs(delta) > 4) movio = true;
    contenedor.scrollLeft = inicioScroll - delta;
    normalizar();
  }

  function soltar() {
    arrastrando = false;
    contenedor.classList.remove('mt-testimonios-arrastrando');
    document.removeEventListener('mousemove', mover);
    document.removeEventListener('mouseup', soltar);
    window.removeEventListener('blur', soltar);
  }
  contenedor.addEventListener('mousedown', function (evento) {
    arrastrando = true;
    movio = false;
    inicioX = evento.clientX;
    inicioScroll = contenedor.scrollLeft;
    contenedor.classList.add('mt-testimonios-arrastrando');
    document.addEventListener('mousemove', mover);
    document.addEventListener('mouseup', soltar);
    window.addEventListener('blur', soltar);
  });
  contenedor.addEventListener('click', function (evento) {
    if (movio) { evento.preventDefault(); }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      soltar();
      pausado = false;
    }
  });
}

function initHeroGaleria(galeria) {
  var slides = galeria.querySelectorAll('.mt-hero-galeria-slide');
  var puntos = galeria.querySelectorAll('[data-mt-hero-punto]');
  if (slides.length < 2) return;

  var indice = 0;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mostrar(nuevoIndice) {
    slides[indice].classList.remove('mt-activa');
    puntos[indice] && puntos[indice].classList.remove('mt-activa');
    indice = nuevoIndice;
    slides[indice].classList.add('mt-activa');
    puntos[indice] && puntos[indice].classList.add('mt-activa');
  }

  puntos.forEach(function (punto, i) {
    punto.addEventListener('click', function () {
      if (i === indice) return;
      mostrar(i);
      reiniciarIntervalo();
    });
  });

  var intervalo;
  function reiniciarIntervalo() {
    if (prefersReduced) return;
    clearInterval(intervalo);
    intervalo = setInterval(function () {
      mostrar((indice + 1) % slides.length);
    }, 4000);
  }
  reiniciarIntervalo();
}

function initBarraFlotante() {
  var barra = document.querySelector('[data-mt-barra-flotante]');
  if (!barra) return;
  var disparador = document.querySelector(barra.getAttribute('data-disparador')) || document.querySelector('.mt-hero, .mt-producto');

  var umbral = disparador ? disparador.getBoundingClientRect().height + disparador.getBoundingClientRect().top + window.scrollY : 400;

  var visible = false;

  function evaluar() {
    var debeVerse = window.scrollY > umbral;
    if (debeVerse !== visible) {
      visible = debeVerse;
      barra.classList.toggle('mt-visible', visible);
    }
  }
  window.addEventListener('scroll', evaluar, { passive: true });
  evaluar();

  var boton = barra.querySelector('[data-mt-barra-boton]');
  if (boton) {
    boton.addEventListener('click', function (e) {
      var destino = boton.getAttribute('href');
      if (destino && destino.charAt(0) === '#') {
        var el = document.querySelector(destino);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }
}

function initAcordeonPoliticas() {
  var items = document.querySelectorAll('.mt-acordeon-politica .mt-acordeon-item');
  if (!items.length) return;

  items.forEach(function (item, indice) {
    var titulo = item.querySelector('.mt-acordeon-titulo');
    var contenido = item.querySelector('.mt-acordeon-contenido');
    if (!titulo || !contenido) return;

    titulo.style.setProperty('--mt-acordeon-num', '"' + (indice + 1) + '"');
    contenido.hidden = true;
    titulo.setAttribute('role', 'button');
    titulo.setAttribute('tabindex', '0');
    titulo.setAttribute('aria-expanded', 'false');

    function alternar() {
      var abierto = titulo.getAttribute('aria-expanded') === 'true';
      contenido.hidden = abierto;
      titulo.setAttribute('aria-expanded', String(!abierto));
      titulo.classList.toggle('mt-acordeon-abierto', !abierto);
    }

    titulo.addEventListener('click', alternar);
    titulo.addEventListener('keydown', function (evento) {
      if (evento.key === 'Enter' || evento.key === ' ') {
        evento.preventDefault();
        alternar();
      }
    });
  });
}

function initMarqueeAnuncio() {
  var mensaje = document.querySelector('.announcement-bar__message');
  if (!mensaje || mensaje.getAttribute('data-mt-marquee-ready')) return;
  var textoEl = mensaje.querySelector('span');
  var texto = (textoEl ? textoEl.textContent : mensaje.textContent).trim();
  if (!texto) return;

  mensaje.setAttribute('data-mt-marquee-ready', '1');
  mensaje.innerHTML = '';
  mensaje.classList.add('mt-marquee');

  var track = document.createElement('span');
  track.className = 'mt-marquee-track';
  for (var i = 0; i < 2; i++) {
    var item = document.createElement('span');
    item.className = 'mt-marquee-item';
    item.textContent = texto;
    if (i === 1) item.setAttribute('aria-hidden', 'true');
    track.appendChild(item);
  }
  mensaje.appendChild(track);
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-i', i % 8);
    observer.observe(el);
  });
}

function initContadores() {
  var contadores = document.querySelectorAll('.mt-contador');
  if (!contadores.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-valor')) || 0;
      var sufijo = el.getAttribute('data-sufijo') || '';
      var decimales = el.getAttribute('data-decimales') ? parseInt(el.getAttribute('data-decimales'), 10) : 0;

      if (prefersReduced) {
        el.textContent = fin.toFixed(decimales) + sufijo;
        observer.unobserve(el);
        return;
      }

      var inicio = 0;
      var duracion = 1400;
      var t0 = null;
      function paso(t) {
        if (t0 === null) t0 = t;
        var progreso = Math.min((t - t0) / duracion, 1);
        var valor = inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales) + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });

  contadores.forEach(function (el) { observer.observe(el); });
}
